import { jsx as _jsx } from "react/jsx-runtime";
export default function RoundedButton({ onClick, title }) {
    return (_jsx("button", { className: "flex w-fit rounded-full bg-white px-5 py-1 text-black", onClick: onClick, children: title }));
}
